import { render, staticRenderFns } from "./single-language-autocomplete.vue?vue&type=template&id=3aade1d3&scoped=true&"
import script from "./single-language-autocomplete.vue?vue&type=script&lang=js&"
export * from "./single-language-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./single-language-autocomplete.vue?vue&type=style&index=0&id=3aade1d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aade1d3",
  null
  
)

export default component.exports